import * as React from 'react';

import { CloseOutlined } from '@ant-design/icons';
import { Modal as AntModal } from 'antd';

type ModalProps = { isOpen: boolean; handleClose: () => void; children: React.ReactNode };

function Modal({ isOpen, handleClose, children }: ModalProps) {
  return (
    <AntModal
      data-testid='stepper-modal'
      open={isOpen}
      onCancel={handleClose}
      width='auto'
      className='font-sans max-md:px-4! [&_.ant-modal-body]:p-16'
      footer={null}
      closeIcon={<CloseOutlined className='text-[#0D47A1]' style={{ fontSize: 24 }} />}
    >
      {children}
    </AntModal>
  );
}

export { Modal };
